!function () {
	"use strict";

	const selectors = {
		marquee: ".announcement__bar-holder--marquee",
		slide: "[data-slide]",
		slider: "[data-slider]",
		ticker: "ticker-bar",
		tickerSlide: ".announcement__slide"
	};

	if (customElements.get("announcement-bar")) {
		return;
	}

	customElements.define("announcement-bar", class extends HTMLElement {
		constructor() {
			super();

			this.slider = this.querySelector(selectors.slider);
			this.slidesCount = this.querySelectorAll(selectors.tickerSlide).length;
			this.resizeEvent = () => this.resize();
		}

		connectedCallback() {
			this.addEventListener("theme:slider:loaded", () => {
				this.querySelectorAll(selectors.ticker).forEach((ticker) => {
					ticker.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
				});
			});

			this.addEventListener("theme:countdown:hide", (event) => {
				if (window.Shopify && window.Shopify.designMode) {
					return;
				}

				const marquee = event.target.closest(selectors.marquee);

				if (this.slidesCount < 2) {
					const ticker = this.querySelector(selectors.ticker);

					if (ticker) {
						ticker.style.display = "none";
					}
				}

				if (marquee) {
					const tickerSlide = event.target.closest(selectors.tickerSlide);

					if (tickerSlide) {
						this.removeTickerText(tickerSlide);
					}

					return;
				}

				const slide = event.target.closest(selectors.slide);

				if (slide) {
					this.removeSlide(slide);
				}
			});

			this.addEventListener("theme:countdown:expire", () => {
				this.querySelectorAll(selectors.ticker).forEach((ticker) => {
					ticker.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
				});
			});

			document.addEventListener("theme:resize:width", this.resizeEvent);
			document.dispatchEvent(new CustomEvent("theme:announcement:init", { bubbles: true }));
		}

		resize() {
			if (!this.slider) {
				return;
			}

			this.slider.dispatchEvent(new CustomEvent("theme:slider:init", { bubbles: false }));
			this.slider.dispatchEvent(new CustomEvent("theme:slider:reposition", { bubbles: false }));
		}

		removeSlide(slide) {
			if (!this.slider || !slide) {
				return;
			}

			this.slider.dispatchEvent(new CustomEvent("theme:slider:remove-slide", {
				bubbles: false,
				detail: { slide }
			}));
		}

		removeTickerText(tickerSlide) {
			if (!tickerSlide) {
				return;
			}

			const ticker = tickerSlide.closest(selectors.ticker);

			tickerSlide.remove();

			if (ticker) {
				ticker.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
			}
		}

		disconnectedCallback() {
			document.removeEventListener("theme:resize:width", this.resizeEvent);
		}
	});
}();